import React, { Component } from 'react';
import jwt_decode from 'jwt-decode'
import axios from 'axios';

import { Table, Button } from 'reactstrap';
class TrialUpload extends Component {
  constructor() {
    super();
    this.state = {
      Ufiles: [],
      id: '',
      firstname: '',
      editoruser: '',
    };
  }


  componentDidMount(){
    const token = localStorage.usertoken
    console.log(token)
    const decoded = jwt_decode(token)
    console.log(decoded.id)
    this.setState({
      firstname: decoded.firstname,
      id: decoded.id,
     })
     

     const id = decoded.id

    const Ufiles =  axios.get(`https://apis.pixelbyhand.com/images/api/${id}`)
    
   .then( response => {
       this.setState({Ufiles: response.data})
       console.log(response);
     })
     // handle success
   }

  render() {

    const {id, firstname} = this.state
  

    const Ufiles = this.state.Ufiles.map(keys => {
      return (
        <tbody  key={keys.id}>
          <tr>
          
              <td>{keys.email}</td>
              <td>{keys.note}</td>
              <td>{keys.created}</td>
              <td> <Button disabled>Working...</Button></td>
          </tr>
         
        </tbody>
     

        

        
      )
    })

    
      
    return (
      <div className="container listup">
      
     <h1>Trial Uploads</h1>
     
     <Table className="tabless">
     <thead>
           <tr className="myform">
            
             <th className="wrow2"><label>Email</label></th>
             <th className="wrow2"><label>Note</label></th>
             <th className="wrow3"> <label>File Upload On Date</label></th>
             <th className="4"><label>Status of Sample Images</label></th>
           
           </tr>
           </thead>
           {Ufiles}
           </Table>
    


    
          
  </div>
        
    )

 
  }
}

export default TrialUpload;